import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
const UploadDropzone = ({ accept, onFileSelected }) => {
    const { t } = useTranslation();
    const inputRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const openFilePicker = () => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    const handleInputChange = (event) => {
        var _a;
        const selectedFile = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (selectedFile) {
            onFileSelected(selectedFile);
        }
        // reset so picking the same file again after a remove still fires onChange
        event.target.value = '';
    };
    const handleDrop = (event) => {
        var _a;
        event.preventDefault();
        setIsDragging(false);
        const selectedFile = (_a = event.dataTransfer.files) === null || _a === void 0 ? void 0 : _a[0];
        if (selectedFile) {
            onFileSelected(selectedFile);
        }
    };
    const handleDragOver = (event) => {
        event.preventDefault();
        setIsDragging(true);
    };
    const handleDragLeave = () => {
        setIsDragging(false);
    };
    const dragStateClasses = isDragging
        ? 'border-blue-600 bg-blue-50'
        : 'border-gray-300 bg-gray-50';
    return (React.createElement("div", { onDrop: handleDrop, onDragOver: handleDragOver, onDragLeave: handleDragLeave, className: `
        flex flex-col items-center justify-center gap-2
        rounded-xl border border-dashed
        px-6 py-12 text-center
        ${dragStateClasses}
      ` },
        React.createElement("span", { className: "flex h-14 w-14 items-center justify-center rounded-2xl bg-gray-200" },
            React.createElement("span", { className: "material-symbols-outlined text-3xl text-gray-700" }, "cloud_upload")),
        React.createElement("p", { className: "mt-2 text-base text-gray-700 md:text-lg" },
            t('pitchCreation.upload.dropzoneTextBefore'),
            ' ',
            React.createElement("button", { type: "button", onClick: openFilePicker, className: "font-medium text-blue-700 underline underline-offset-2" }, t('pitchCreation.upload.dropzoneChooseFile')),
            ' ',
            t('pitchCreation.upload.dropzoneTextAfter')),
        React.createElement("p", { className: "text-sm text-gray-500" }, t('pitchCreation.upload.helper')),
        React.createElement("input", { ref: inputRef, type: "file", accept: accept, className: "hidden", onChange: handleInputChange })));
};
export default UploadDropzone;
